import { mapState } from 'vuex';
import UserRoleChange from '@/components/user/role/edit/UserRoleChange.vue';

export default {
  name: 'UserRoleChangeContainer',
  components: { UserRoleChange },

  data () {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user
    }),

    canChangeUserRole () {
      return this.ApiRequest.userHasPermission('view-role-change');
    },

    userMenu () {
      const menu = [];
      if (this.canChangeUserRole) {
        menu.push({ text: 'menu.user.dropdown.role', name: 'menu.user.dropdown.role' });
      }

      return menu;
    }
  },

  methods: {
    changeRole () {
      this.$refs.userRoleChange.changeRole();
    }
  }
}
